<template>
  <footer class="app-footer">
    <div class="app-footer__inner">

      <!-- Left: branding -->
      <div class="app-footer__brand">
        <div class="app-footer__logo">
          <v-icon color="#4ADE80" size="18">mdi-shield-check</v-icon>
        </div>
        <div>
          <div class="app-footer__brand-name">SARPA Kerala</div>
          <div class="app-footer__brand-sub">Snake Rescue Operations Platform</div>
        </div>
      </div>

      <!-- Center: copyright -->
      <div class="app-footer__copy">
        <v-icon size="13" color="rgba(255,255,255,0.3)" class="mr-1">mdi-copyright</v-icon>
        {{ new Date().getFullYear() }} Kerala Forest Department. All rights reserved.
      </div>

      <!-- Right: credit -->
      <div class="app-footer__credit">
        <span class="app-footer__credit-label">Designed &amp; maintained by</span>
        <span class="app-footer__credit-name">
          <v-icon size="12" color="#4ADE80" class="mr-1">mdi-code-braces</v-icon>
          Leopard Tech Labs
        </span>
      </div>

    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style scoped>
.app-footer {
  background: linear-gradient(135deg, #0A2318 0%, #14532D 100%);
  border-top: 1px solid rgba(74, 222, 128, 0.15);
}

.app-footer__inner {
  max-width: 1400px;
  margin: 0 auto;
  padding: 18px 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}

/* ── Brand ── */
.app-footer__brand {
  display: flex;
  align-items: center;
  gap: 10px;
}
.app-footer__logo {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: rgba(74, 222, 128, 0.12);
  border: 1px solid rgba(74, 222, 128, 0.25);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.app-footer__brand-name {
  font-size: 13px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 0.02em;
  line-height: 1.2;
}
.app-footer__brand-sub {
  font-size: 10px;
  color: rgba(255, 255, 255, 0.4);
  font-weight: 500;
  letter-spacing: 0.03em;
  margin-top: 1px;
}

/* ── Copyright ── */
.app-footer__copy {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.45);
  font-weight: 500;
  display: flex;
  align-items: center;
  text-align: center;
}

/* ── Credit ── */
.app-footer__credit {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
}
.app-footer__credit-label {
  font-size: 10px;
  color: rgba(255, 255, 255, 0.35);
  font-weight: 500;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}
.app-footer__credit-name {
  font-size: 12px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.75);
  display: flex;
  align-items: center;
}

/* ── Responsive ── */
@media (max-width: 700px) {
  .app-footer__inner {
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 20px 16px;
    gap: 14px;
  }
  .app-footer__credit {
    align-items: center;
  }
}
</style>